



























































import { Component, Vue, Prop } from "vue-property-decorator"
import { mapGetters } from "vuex"
import ReportMarginVue from "./ReportMargin.vue"
@Component({
    ...mapGetters(["accountBook"]),
    components: {
        "report-margin": ReportMarginVue
    }
})
export default class GenAllPrint extends Vue {
    @Prop({ type: Object })
    dataList!: Subsidiary[];

    @Prop({ type: String })
    period!: string;

    @Prop({ type: Number })
    idx!: number;

    @Prop({ type: Boolean, default: false })
    noSelect!: boolean;

    @Prop({ type: String })
	fontSize!: string;

}
